/**
 * Personalization Form Fields Block Frontend Behavior
 *
 * Handles the "Simplify Known Fields" functionality.
 * This file runs only on the frontend where the form fields are displayed.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

(() => {
	/**
	 * Initialize form fields behavior
	 */
	function initFormFieldsBehavior() {
		const form = document.querySelector('.sm-personalization-form');
		if (!form) {
			return;
		}

		// Check if summary section exists (server-rendered)
		const summary = form.querySelector('.sm-personalization-form-known-info');

		if (!summary) {
			return; // No known fields to simplify
		}

		summary.style.display = 'block';

		const knownFields = [];

		// Find and hide all form items that have default values
		const formItems = form.querySelectorAll('.sm-personalization-form-item');
		formItems.forEach((item) => {
			const input = item.querySelector('.sm-personalization-form-item-input');

			if (!input) {
				return;
			}

			// Check if this field has a default value
			if (hasDefaultValue(input)) {
				hideField(item);
				knownFields.push(item);
			}
		});

		// Exit if no fields were hidden
		if (knownFields.length === 0) {
			// Remove the summary if no fields are actually hidden
			summary.remove();
			return;
		}

		// Setup the "Update" button handler
		const updateButton = summary.querySelector(
			'.sm-personalization-form-known-info-update-button',
		);
		if (updateButton) {
			updateButton.addEventListener('click', (e) => {
				e.preventDefault();

				// Remove the summary section
				summary.remove();

				// Show all hidden fields
				knownFields.forEach((field) => {
					showField(field);
				});
			});
		}
	}

	/**
	 * Check if an input has a default value
	 *
	 * @param {HTMLInputElement|HTMLSelectElement} input - The input element to check
	 * @returns {boolean} True if input has a default value
	 */
	function hasDefaultValue(input) {
		if (input.tagName === 'SELECT') {
			// Select has default if a non-empty value is selected
			return input.value !== '';
		} else {
			// Text/hidden inputs have default if value attribute is non-empty
			return input.value.trim() !== '';
		}
	}

	/**
	 * Hide a form field
	 *
	 * @param {HTMLElement} fieldElement - The form item element to hide
	 */
	function hideField(fieldElement) {
		fieldElement.classList.add('sm-personalization-form-item--hidden');
	}

	/**
	 * Show a form field
	 *
	 * @param {HTMLElement} fieldElement - The form item element to show
	 */
	function showField(fieldElement) {
		fieldElement.classList.remove('sm-personalization-form-item--hidden');
	}

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initFormFieldsBehavior);
	} else {
		initFormFieldsBehavior();
	}
})();
